import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { Modal } from 'react-bootstrap';
import { ImageSecurityAlert } from '../../assets/images';
import { Button } from '..';
import './IdvPendingModal.scss';
import { IdvStatus } from '../../types/trip.type';
import { ReservationUtils, TranslationUtils } from '../../utils';
import { fetchTrip } from '../../store/actions';
import * as _ from 'lodash';

export const IdvPendingModal: React.FC = () => {
    const trip = useSelector((store: StoreState) => store.trip);
    const [isShowing, setIsShowing] = useState<boolean>(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!trip.idv) {
            return;
        }

        const shouldShow = !_.isEmpty(trip.idv.url) && trip.idv.status !== IdvStatus.PASSED;
        setIsShowing(shouldShow);
    }, [trip.idv]);

    const handleVerify = () => {
        const url = trip.idv?.url;
        window.open(url, '_blank');
    };

    const handleAlreadyCompletedClick = async () => {
        dispatch(fetchTrip(true));
    };

    return (
        <Modal id="idv-pending-modal" show={isShowing} backdropClassName={'custom-modal-backdrop'} onHide={() => null}>
            <Modal.Header />
            <Modal.Body className="idv-modal-body">
                <div>
                    <ImageSecurityAlert className="idv-modal-image" />
                </div>
                <h5 className={'heading-med-light'}>{TranslationUtils.get('identity_check_required')}</h5>

                <div className="body-regular idv-modal-reservation">
                    {trip.confirmation_code ? (
                        <React.Fragment>
                            {`${TranslationUtils.get('confirmation')} ${ReservationUtils.formatConfirmationCode(trip.confirmation_code)}`}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>{`${TranslationUtils.get('reservation')} ${trip.id}`}</React.Fragment>
                    )}
                </div>

                <Button
                    variant="primary"
                    label={TranslationUtils.get('verify_identity')}
                    onClick={handleVerify}
                    isLoading={trip.isLoading}
                    className={'body-regular'}
                />

                <div className="idv-help-instructions">
                    <span className={'body-regular'}>{TranslationUtils.get('already_completed_idv')}</span>
                    <a className={'body-regular'} role="button" onClick={handleAlreadyCompletedClick}>
                        {TranslationUtils.get('click_here')}
                    </a>
                </div>
            </Modal.Body>
        </Modal>
    );
};
